// extracted by mini-css-extract-plugin
export default {"contactMe":"ContactMe_contactMe__q9Qhc","social":"ContactMe_social__bOU6K"};